import { Directive, Input, OnInit } from '@angular/core';
import { prepareMasters } from 'src/app/modules/my-journey/components/offer-onb-field-details/offer-onb-field-details.component';

@Directive({
  selector: '[extendedFieldsDirective]'
})
export class extendedFieldsDirective implements OnInit {
  @Input() form_group;
  @Input() form_control;
  @Input() extendedFields;
  @Input() field;
  @Input() masters;
  @Input() section;
  constructor() { }
  ngOnInit() {
    if (this.field && this.extendedFields && this.masters) {
      prepareMasters(this.field, this.extendedFields, this.masters, this.section)
    }
    setTimeout(() => {
      try {
        this.form_group.get(this.form_control).patchValue(this.extendedFields[this.form_control]);
      }
      catch (err) {
        console.log(err)
      }
    });
  }
}
